import { Highlighter } from '@ifs-gcp/components';
import type { ChecklistRequirement } from '@ifs-gcp/core';

import { getTranslation } from '@/utils/translations';

type RequirementCellProps = {
  row: ChecklistRequirement;
  language: string;
  search: string;
};

export const RequirementCell = ({ row, language, search }: RequirementCellProps) => {
  return (
    <Highlighter search={search} content={getTranslation(row.template.requirementText, language)} />
  );
};
